import BaseCrmEnrichmentToggleContainer from "app/pages/sales-intelligence/modules/crm-enrichment/containers/CrmEnrichmentToggleContainer";
import type { CrmEnrichmentJob } from "app/pages/sales-intelligence/modules/crm-enrichment/types/types";

import useHsEnrichmentJobToggleMutation from "../../mutations/useHsEnrichmentJobToggleMutation";

type EnrichmentToggleProps = {
    job: CrmEnrichmentJob;
    onRenameClick?: (job: CrmEnrichmentJob) => void;
    onDeleteClick?: (job: CrmEnrichmentJob) => void;
};

const HsEnrichmentJobToggle = ({ job, onRenameClick, onDeleteClick }: EnrichmentToggleProps) => {
    const { mutate: mutateToggle } = useHsEnrichmentJobToggleMutation();

    const handleMutateToggle = (jobId: string, value: boolean) => {
        mutateToggle({ jobId, value });
    };

    return (
        <BaseCrmEnrichmentToggleContainer
            job={job}
            onToggle={handleMutateToggle}
            onRenameClick={onRenameClick}
            onDeleteClick={onDeleteClick}
        />
    );
};

export default HsEnrichmentJobToggle;
